export enum CompanyHubSettingsPageTabsType {
	GENERAL = 0,
	ANALYTICS = 1,
	USERS = 2,
}
